import { useEffect, useState } from 'react';
import { GetCLOSETGroupInfoResponse } from 'types/api/groups/closet';
import { getGroupInfo } from 'api/groups/closet';

interface Params {
  groupId: string;
}

export const useCLOSETGroupInfoQuery = ({ groupId }: Params) => {
  const [data, setData] = useState<GetCLOSETGroupInfoResponse | null>(null);
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchGroupPlanDetail = async () => {
      try {
        setIsLoading(true);
        const response = await getGroupInfo({ groupId }); // Replace with actual group ID
        setData(response);
      } catch (error) {
        console.error('Error fetching group plan detail:', error);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    void fetchGroupPlanDetail();
  }, []);

  return { data, isError, isLoading };
};
